@if (user | async; as user) {
  <app-user-profile-card
    [user]="user"
    (profileChanged)="profileChanged($event)"
  ></app-user-profile-card>
  <app-ssh-keys-card [orgaId]="(orgaId | async) || ''" [orgaUserId]="(orgaUserId | async) || ''"></app-ssh-keys-card>
}
